<template>
    <div>
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>รหัสชีท</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="replace_sheet.code"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>ชื่อชีท</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="replace_sheet.name"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right">
                <label>จำนวนชีทคงเหลือ (ม้วน)</label>
            </b-col>
            <b-col sm="6">
                <input
                    class="form-control"
                    type="text"
                    v-model="replace_sheet.quantity"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right">
                <label>จำนวนที่นำออก (ม้วน)</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="number"
                    v-model="form.quantity"/></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>หมายเหตุ</label></b-col>
            <b-col sm="6">
                <textarea
                    class="form-control"
                    v-model="form.reason">
                </textarea>
            </b-col>
        </b-row>
        <br />
        <b-row>
            <div class="col text-center">
                <button
                        :disabled="form.onSave"
                    type="button"
                    class="btn btn-success"
                    @click="onSubmitSheetExport">
                    <icon name="save" style="width: 25px"></icon> บันทึก</button>&nbsp&nbsp
                <button type="button"
                        @click="cancalModal"
                        class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
        <!--<pre class="alert alert-primary">{{ replace_sheet }}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
import FormTextarea from "bootstrap-vue/src/components/form-textarea/form-textarea";
export default {
    name: "export-sheet-modal",
    components: { FormTextarea },
    data() {
        return {
            form: {
                quantity: "",
                machine: "",
                reason: "",
                code: "",
                onSave: false,
            }
        };
    },
    created(){

    },
    computed: {
        ...mapState({
            replace_sheet: state => {
                return state.Sheet.form;
            },
            user: state => {
                return state.Auth.user;
            },
        })
    },
    methods: {
        onSubmitSheetExport() {
            if(!this.form.quantity || this.form.quantity < 0){
                alert("กรุณาใส่จำนวนให้ถูกต้อง");
            }else{
                let data = {
                    sheet_id : this.replace_sheet.id,
                    sheet_type_id : this.replace_sheet.sheet_type.id,
                    quantity: this.form.quantity,
                    reason: this.form.reason,
                    user_id: this.user.id
                };
                if (this.replace_sheet.quantity < data.quantity) {
                    alert(
                        "ไม่สามารถเบิกชีทได้ เนื่องจากชีทที่ท่านต้องการไม่เพียงพอ"
                    );
                } else {
                    this.form.onSave = true;
                    this.$emit("submit", data);
                    this.form = {
                        quantity: "",
                        machine: "",
                        reason: "",
                        code: "",
                        onSave: false,
                    }
                }
            }
        },
        cancalModal(){
            this.$emit("submit", "cancel");
            this.form = {
                quantity: "",
                machine: "",
                reason: "",
                code: "",
                onSave: false,
            }
        }
    }
};
</script>

<style scoped></style>
